import React, { Component } from 'react'
import { Table, Icon, Button } from 'antd'
import { TableAction } from 'components/TableAction'
import { MODAL_TYPES } from 'components/ModalFactory'
import { ModalFactory } from 'components/ModalFactory'
import { Permissions } from 'permissions'
import { BaseRequest, OrganizationRequest, SearchOrganizationRequest } from 'models/request/Index'
import { PushNotification } from 'utils/PushNotification'
import { addUserInApplication, deleteUserInApplication, getOrganizationTeam } from 'services/CeberusApiService'
import { Tenant } from 'models/Blip/Index'
import { TenantService } from 'connection/TenantService'
import { OrganizationTeamResponse } from 'models/response/OrganizationTeamResponse'
import { PermissionService } from 'services/PermissionService'

const { Column } = Table;

const UNRECOGNIZED_MODAL_TYPE = 'Unrecognized modal type'

export class OrganizationTeam extends Component<BaseRequest> {

  formRef : any;
  tenantSelected: Tenant;

  state = {
    isLoading: false,
    isConfigModalVisible: false,
    tableRows: [],
    searchingIdentifier: '',
    searchText: '',
    currentModal: '',
    removeRecord: {},
    listOrganizationTeamResponse: new Array<OrganizationTeamResponse>(),
    canAdd: PermissionService.hasPermission(Permissions.Organization_Team__Add),
    canRemove: PermissionService.hasPermission(Permissions.Organization_Team__Remove),
  }

  componentDidMount(){
    this.tenantSelected = TenantService.getSelectedTenant();
    this.onSearch(this.props.BotIdentifier)
  }

  setComponentLoading(isLoading: boolean) : void {
    this.setState({ isLoading })
  }

  handleModalVisibility = (type: string, visibility: boolean) : void => {
    switch(type) {
      case MODAL_TYPES.AddTemOrganization :
        if (!this.state.canAdd) return
      case MODAL_TYPES.RemoveTemOrganization :
        this.setState({
          isConfigModalVisible: visibility,
          currentModal: type,
        })

        if (!visibility) {
          this.setState({ removeRecord: {} })
        }
        break
      default:
        PushNotification.error(UNRECOGNIZED_MODAL_TYPE);
    }
  }

  handleSaveOrganizationTeam = () : void => {
    const form = this.formRef.props.form;

    form.validateFields(async (err, values) => {
      if (err) {
        return
      }

      try {
        const { organization, userIdentity } = values

        const request = new OrganizationRequest();
        request.ClusterName = this.tenantSelected.name;
        request.OrganizationId = organization;
        request.ApplicationName = this.state.listOrganizationTeamResponse.shift().ApplicationName;
        request.BotIdentifier = this.props.BotIdentifier;
        request.UserIdentity = userIdentity;

        const response = await addUserInApplication(request);

        form.resetFields();
        this.bindTableRowsByIdentifier(this.state.searchingIdentifier);
        this.handleModalVisibility(MODAL_TYPES.AddTemOrganization, false);

        PushNotification.success(response);
      } catch(error) {
        PushNotification.httpError(error);
      }
    })
  }

  saveFormRef = (formRef: any) : void => {
    this.formRef = formRef
  }

  onSearch = async (identifier: string) => {
    try {
      this.setComponentLoading(true);
      await this.bindTableRowsByIdentifier(identifier);
    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setComponentLoading(false);
    }
  }

 bindTableRowsByIdentifier = async (identifier: string) : Promise<void> => {
   const request = new SearchOrganizationRequest();
   request.ClusterName = this.tenantSelected.name;
   request.BotIdentifier = identifier;

   const response = await getOrganizationTeam(request);

   this.setState(prevState => ({
     ...prevState,
     searchingIdentifier: identifier,
     listOrganizationTeamResponse : response,
     tableRows: response.map((rows: any, index: number) => ({
       ...rows,
       key: index
     }))
   }))
 }

  onRemove = async (organizationTeamResponse: OrganizationTeamResponse) => {
    if (!this.state.canRemove) return
    try {
      this.setComponentLoading(true);
      const request = new OrganizationRequest();
      request.ClusterName = this.tenantSelected.name;
      request.OrganizationId = organizationTeamResponse.OwnerIdentity;
      request.BotIdentifier = organizationTeamResponse.Identifier;
      request.UserIdentity = organizationTeamResponse.UserIdentity;
      const response = await deleteUserInApplication(request);
      this.bindTableRowsByIdentifier(this.state.searchingIdentifier);
      PushNotification.success(response);
    } catch (error) {
      PushNotification.httpError(error);
    } finally {
      this.setComponentLoading(false);
    }
  }

  filterByRecord = (record: OrganizationTeamResponse, value: string) => {
    const lowerCasedValue = value.toLowerCase()

    return record.Identifier.toLowerCase().includes(lowerCasedValue)
      || record.UserIdentity.toLowerCase().includes(lowerCasedValue)
      || record.Actions.toLowerCase().includes(lowerCasedValue)
  }

  render() {
    return (
      <div className="">
        <div>
          <Button
            type="primary"
            onClick={() => this.handleModalVisibility(MODAL_TYPES.AddTemOrganization, true)}
            disabled={!this.state.canAdd} >
            <Icon type="plus-circle" /> Add User
          </Button>

          <ModalFactory
            wrappedComponentRef={this.saveFormRef}
            visible={this.state.isConfigModalVisible}
            onCancel={() => this.handleModalVisibility(MODAL_TYPES.AddTemOrganization, false)}
            onOk={this.handleSaveOrganizationTeam}
            type={this.state.currentModal}
            record={this.state.removeRecord}
            maskClosable={false}
          />
        </div>

        <Table
          dataSource={this.state.tableRows}
          loading={this.state.isLoading}
        >
          <Column 
            key='UserIdentity' 
            title='User'
            dataIndex='UserIdentity'/>
          <Column 
            title='Allowed Actions'
            render={(_, record: any) => (
              <TableAction onRemove={this.state.canRemove ? () => this.onRemove(record): undefined} />
            )}/>
        </Table>
      </div>
    )
  }
}